import React from 'react';
import { RichTableState, TableConfig } from './types';
import { View } from 'react-native';
import { StandaloneCheckbox } from '../Inputs/Checkbox';

export type RowDataOrHeader = { isHeader: false; row: any; rowIndex: number } | { isHeader: true };

export type SelectionCheckboxOwnProps = {
    state: RichTableState;
    onStateChange: (newState: RichTableState) => void;
    allowRowSelection?: boolean;
    config: TableConfig<any>;
    data: any[];
} & RowDataOrHeader;

export type SelectionCheckboxProps = SelectionCheckboxOwnProps;

const checkboxColumnWidth = 40;

export type UseRowSelectionArgs = {
    onStateChange: (newState: RichTableState) => void;
    state: RichTableState;
    allData: any[];
    config: TableConfig<any>;
} & RowDataOrHeader;

export type UseOnRowSelectionReturnValue = {
    checkboxValue: boolean;
    onChange: () => void;
};

export const useRowSelection = (args: UseRowSelectionArgs) => {
    const getValue = () => {
        if (args.isHeader) {
            return (
                !!args.allData.length &&
                args.state.selectedRowKeys.length === args.allData.length &&
                args.allData.every((row) => args.state.selectedRowKeys.includes(args.config.getRowKey(row)))
            );
        } else {
            return args.state.selectedRowKeys.includes(args.config.getRowKey(args.row));
        }
    };

    const onChange = () => {
        if (args.isHeader) {
            if (getValue()) {
                args.onStateChange({ ...args.state, selectedRowKeys: [] });
            } else {
                args.onStateChange({
                    ...args.state,
                    selectedRowKeys: args.allData.map((row) => args.config.getRowKey(row)),
                });
            }
        } else {
            const rowKey = args.config.getRowKey(args.row);
            if (args.state.selectedRowKeys.includes(rowKey)) {
                args.onStateChange({
                    ...args.state,
                    selectedRowKeys: args.state.selectedRowKeys.filter((key) => key !== rowKey),
                });
            } else {
                args.onStateChange({
                    ...args.state,
                    selectedRowKeys: [...args.state.selectedRowKeys, rowKey],
                });
            }
        }
    };

    return { checkboxValue: getValue(), onChange };
};

const SelectionCheckbox: React.FC<SelectionCheckboxProps> = (props) => {
    const { checkboxValue, onChange } = useRowSelection({
        allData: props.data,
        ...props,
    });

    if (!props.allowRowSelection) return null;

    const getIsDisabled = () => {
        if (props.isHeader) {
            return !props.data.length;
        }
        return false;
    };

    const getIndeterminate = () => {
        if (props.isHeader) {
            return props.state.selectedRowKeys.length > 0 && props.state.selectedRowKeys.length < props.data.length;
        }
        return false;
    };

    return (
        <View
            style={[
                { width: checkboxColumnWidth, justifyContent: 'center', alignItems: 'center', alignSelf: 'stretch' },
            ]}
        >
            <View
                style={[
                    {
                        width: checkboxColumnWidth,
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: 1,
                        // height: '100%',
                    },
                ]}
            >
                <StandaloneCheckbox
                    value={checkboxValue}
                    onChange={onChange}
                    indeterminate={getIndeterminate()}
                    isDisabled={getIsDisabled()}
                    testID={props.isHeader ? 'select-all-checkbox' : `select-row-checkbox-row-${props.rowIndex}`}
                    hasError={false}
                />
            </View>
        </View>
    );
};

export default React.memo(SelectionCheckbox);
